import { createAsyncThunk } from "@reduxjs/toolkit";
import API_BASE_URL, { BoardMedium_URL } from "../../config";
import { clearEdit } from "./subjectSlice";
import axios from "axios";

// FETCH ALL SUBJECTS
export const fetchSubjects = createAsyncThunk(
  "subject/fetchSubjects",
  async () => {
    const response = await fetch(`${API_BASE_URL}/subjects`);
    if (!response.ok) throw new Error("Failed to fetch subjects");
    return await response.json();
  },
);

// FETCH CLASSES
export const fetchClasses = createAsyncThunk(
  "subject/fetchClasses",
  async () => {
    const response = await fetch(`${API_BASE_URL}/classes`);
    if (!response.ok) throw new Error("Failed to fetch classes");
    return await response.json();
  },
);

// SAVE SUBJECT (ADD / UPDATE)
export const saveSubject = createAsyncThunk(
  "subject/saveSubject",
  async (_, { getState, dispatch }) => {
    const {
      subject: { subjectName, selectedClassIds, editingSubject },
    } = getState();

    const method = editingSubject ? "PUT" : "POST";
    const url = editingSubject
      ? `${API_BASE_URL}/subjects/${editingSubject.subject_id}`
      : `${API_BASE_URL}/subjects`;

    const response = await fetch(url, {
      method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        subject_name: subjectName,
        class_ids: selectedClassIds,
      }),
    });

    if (!response.ok) throw new Error("Failed to save subject");

    dispatch(clearEdit());
    dispatch(fetchSubjects());
  },
);

// DELETE SUBJECT
export const deleteSubject = createAsyncThunk(
  "subject/deleteSubject",
  async (subjectId, { dispatch }) => {
    const response = await fetch(`${API_BASE_URL}/subjects/${subjectId}`, {
      method: "DELETE",
    });
    if (!response.ok) throw new Error("Failed to delete subject");

    dispatch(fetchSubjects());
  },
);
export const createSubject = createAsyncThunk(
  "subjects/createSubject",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axios.post(
        `${BoardMedium_URL}/create-subject`,
        payload,
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data || { message: "Failed to create subject" },
      );
    }
  },
);
export const updateSubjectMedium = createAsyncThunk(
  "subjects/updateSubjectMedium",
  async ({ subjectId, payload }, { rejectWithValue }) => {
    try {
      const res = await axios.put(
        `${BoardMedium_URL}/update-subject-medium/${subjectId}`,
        payload
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data || { message: "Failed to update subject" }
      );
    }
  }
);
export const toggleSubjectStatus = createAsyncThunk(
  "subjects/toggleStatus",
  async (subjectId, { rejectWithValue }) => {
    try {
      const res = await axios.put(
        `${BoardMedium_URL}/toggle-subject-status/${subjectId}`
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data || { message: "Failed to toggle subject status" }
      );
    }
  }
);
export const getSubjects = createAsyncThunk(
  "subjects/fetchByBoard",
  async ({ boardId, page = 1, limit = 10 }, { rejectWithValue }) => {
    try {
      const res = await axios.get(
        `${BoardMedium_URL}/subjects/${boardId}?page=${page}&limit=${limit}`
      );

      return {
        subjects: res.data.data,
        pagination: res.data.pagination,
      };

    } catch (err) {
      return rejectWithValue(
        err.response?.data || { message: "Failed to fetch subjects" }
      );
    }
  }
);
